<template>
    <div ref="a4" class="blank-page">
        <template v-if="selected_signs.length == 0">
            <div v-for="index in pages" :key="index" class="wrapper" :class="{ break: index > 0 }">
                <div v-for="cell in 8" :key="cell" class="sign">
                    <SingleSaleForEightCatalogy />
                </div>
            </div>
        </template>
        <template v-else>
            <div v-for="(page, index) in pagination.pages" :key="page" class="wrapper" :class="{ break: index > 0 }">
                <template v-for="sign in pagination.signs[index]" :key="sign.duplicate_inx || sign.promoCode">
                    <div class="sign">
                        <SignSaleForShmone :sign="sign" />
                    </div>
                </template>
            </div>
        </template>
    </div>
</template>

<script>
import { ref } from '@vue/reactivity'
import { is_sales_print, pagination_signs } from '../Scripts/scripts'
import { is_deleted, printer_amount, selected_deals } from '../components/Deals/Scripts/store'
import { defineAsyncComponent, watch } from '@vue/runtime-core'

export default {
    props: ['pages', 'selected_signs'],
    components: {
        SignSaleForShmone: defineAsyncComponent(() => import('./components/SignSaleForShmone.vue')),
        SingleSaleForEightCatalogy: defineAsyncComponent(() => import('../components/ShilutCatalogy/SingleSaleForEightCatalogy.vue'))
    },
    setup(props) {

        const { organise_signs, pagination } = pagination_signs()

        const a4 = ref()

        /*
            שמיניית שלטים מבצע חם:
            8 שלטים בדף (2 עמודות על 4 שורות) מודפסים על נייר ממותג.
            בכל שלט התוכן חייב להישאר 1.5 ס"מ מתחת לקצה העליון ו-1 ס"מ מעל הקצה התחתון.
            השוליים הם padding בתוך כל תא (לא תלויים בהגדרות דיאלוג ההדפסה)
            ו-overflow:hidden מבטיח שהתוכן לא יחרוג מהם.
        */
       
        const handle_print = () => {
            var styleElem = document.createElement('style');
            styleElem.type = 'text/css';
            var css = `
        @import url('https://fonts.googleapis.com/css2?family=Rubik:wght@300;400;500;700&display=swap');

        * {
        direction: rtl;
        font-family: 'Rubik', sans-serif;
        font-weight: normal;
        padding: 0;
        margin: 0;
        box-sizing: border-box;
        }

        h1 {
        font-size: inherit;
        }

        @page {
        size: A4;
        margin: 0;
        }

        @media print {
        .no-see-in-print,
        .float-icon,
        .add-icon,
        .clean-icon {
            display: none;
        }

        .break {
            page-break-before: always;
        }
        }

        .blank-page {
        width: 100%;
        }

        .wrapper {
        width: 100%;
        height: 29.6cm;
        display: grid;
        grid-template-columns: repeat(2, 50%);
        grid-auto-rows: 7.4cm;
        }

        .blank-page .sign {
        position: relative;
        width: 100%;
        height: 100%;
        /* אזור שמור: 1.5 ס"מ מלמעלה ו-1 ס"מ מלמטה בכל שלט */
        padding: 1.5cm 0.3cm 1cm 0.3cm;
        overflow: hidden;
        }

        .sign-sale {
        position: relative;
        width: 100%;
        height: 100%;
        }

        .sign-sale-header {
        position: relative;
        width: 100%;
        height: 4%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 10px;
        text-align: center;
        }

        .sign-sale-input-texts {
        position: relative;
        width: 100%;
        height: 32%;
        font-size: 25px;
        }

        .sign-sale-input-texts .he,
        .sign-sale-input-texts .ru {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;
        font-size: 25px;
        padding: 0 4px;
        overflow: hidden;
        }

        .sign-sale-input-texts .he h1 {
        font-weight: bold;
        }

        .sign-sale-input-texts .ru {
        font-size: 12px;
        }

        /* כמות יח' במחיר מוצגת בשורה אחת (כמו ברביעיית שלטים מבצע חם),
           עם מספרים גדולים ותווית קטנה יותר, מוקטן כדי שלא יחרוג מהשוליים */
        .sign-sale-contents {
        width: 100%;
        height: 40%;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: center;
        align-items: center;
        gap: 14px;
        font-size: 30px;
        white-space: nowrap;
        overflow: hidden;
        }

        .col {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        }

        .sign-sale-contents > .col {
        height: auto;
        flex-direction: row;
        }

        .col.small {
        font-size: 24px;
        text-align: center;
        }

        /* הכמות באותו גודל ועובי כמו המחיר */
        .sign-sale-contents > .col:first-child {
        font-size: 33px;
        }

        .sign-sale-contents > .col:first-child span {
        font-size: 22px;
        }

        .sign-sale-contents > .col:last-child {
        font-size: 33px;
        }

        /* הכמות והמחיר מודגשים בהדפסה — עוקף את font-weight:normal הגלובלי */
        .sign-sale-contents > .col:first-child h1,
        .sign-sale-contents > .col:first-child span,
        .sign-sale-contents > .col:last-child h1,
        .sign-sale-contents > .col:last-child .shekel {
        font-weight: 700;
        }

        .shekel {
        font-size: 22px;
        }

        .grams {
        font-size: 12px;
        }

        .sign-sale-footer {
        width: 100%;
        height: 24%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 2px 4px;
        overflow: hidden;
        }

        .sign-sale-footer.item-error {
        justify-content: center;
        align-items: center;
        color: red;
        font-size: 12px;
        }

        .col.price {
        width: 100%;
        font-size: 12px;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        order: 1;
        padding: 1px 0;
        }

        .col.price > small {
        font-weight: 500;
        font-size: 14px;
        white-space: nowrap;
        }

        .prormo-limit {
        width: 100%;
        font-size: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;
        }
        .prormo-limit p {
        margin: 0;
        white-space: nowrap;
        }

        .col.barcodes {
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        order: 2;
        gap: 4px;
        overflow: hidden;
        }

        .col.barcodes h1 {
        font-size: 9px;
        }

        [data-slice] {
        white-space: nowrap;
        overflow: hidden;
        margin-right: 4px;
        font-size: 9px;
        }

        [data-fixed] {
        display: flex;
        align-items: center;
        font-size: 10px;
        }

        .choos-item {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: var(--main);
        z-index: 1000;
        }
    `;

            if (styleElem.styleSheet) {
                styleElem.styleSheet.cssText = css;
            }
            else {
                styleElem.appendChild(document.createTextNode(css));
            }

            let newWin = window.open('', '', 'height=500, width=500');
            newWin.document.write(a4.value.outerHTML);
            newWin.document.getElementsByTagName('head')[0].appendChild(styleElem);
            newWin.document.close();
            setTimeout(() => {
                is_sales_print.value = false
                newWin.print();
            }, 1000);
        }

        const handle_print_catalogy = () => {
            var styleElem = document.createElement('style');
            styleElem.type = 'text/css';
            var css = `
                  @import url('https://fonts.googleapis.com/css2?family=Rubik:wght@300;400;500&display=swap');
                  *{
                      direction:rtl;
                      font-family: 'Rubik', sans-serif;
                      font-weight:normal;
                      padding: 0;
                      margin: 0;
                      box-sizing: border-box;
                  }
                  h1{
                      font-size: inherit;
                  }
                  @media print {
                      .no-see-in-print{
                          display:none;
                      }
                      .float-icon{
                          display:none;
                      }
                      .add-icon,.clean-icon{
                          display:none;
                      }
                      .break{
                          page-break-before: always;
                      }
                  }
                  @page {
                    size: A4;
                    margin: 0;
                }
                  .blank-page{
                      width:100%;
                  }
                 .wrapper{
                      width: 100%;
                      height: 29.6cm;
                      display: grid;
                      grid-template-columns: repeat(2, 50%);
                      grid-auto-rows: 7.4cm;
                  }
                  .blank-page .sign{
                      position: relative;
                      width: 100%;
                      height: 100%;
                      padding: 1.5cm 0.3cm 1cm 0.3cm;
                      overflow: hidden;
                  }
                  .sign-sale{
                      width: 100%;
                      height: 100%;
                  }
                  .sign-sale-header{
                      position: relative;
                      width: 100%;
                      height: 15%;
                      display: flex;
                      justify-content: center;
                      align-items: center;
                      font-size: 14px;
                      border-bottom: 1px solid black;
                  }
                  .logo{
                      position: absolute;
                      width: 100px;
                      height: 100%;
                      top: 5px;
                      left: 5px;
                      display: flex;
                      justify-content: center;
                      align-items: center;
                  }
                  .logo img{
                      width: 100px;
                      height: 30px;
                  }
                  .sign-sale-input-texts{
                      position: relative;
                      width: 100%;
                      height: 35%;
                  }
                  .sign-sale-input-texts .he,.sign-sale-input-texts .ru{
                      width: 100%;
                      height: 100%;
                      display: flex;
                      flex-direction: column;
                      align-items: center;
                      justify-content: center;
                      font-size: 15px;
                      text-align: center;
                  }
                  .sign-sale-input-texts .ru{
                      font-size:10px;
                  }
                  .sign-sale-contents {
                      width: 100%;
                      height: 40%;
                      font-size: 18px;
                      display: grid;
                      place-items: center;
                  }
                  .col{
                      display: flex;
                      justify-content: center;
                      align-items: center;
                  }
                  .col-1{
                      width: 10%;
                      height: 100%;
                  }
                  .col-2{
                      width: 45%;
                      height: 100%;
                  }
                  .col.barcodes{
                      justify-content:unset;
                      padding: 0 5px;
                      width: 40%;
                      font-size: 8px;
                  }
                  .col.small{
                      font-size: unset;
                      text-align: center;
                      width: 30%;
                      font-size: 16px
                  }
                   .col.price{
                      width: 30%;
                      font-size: 16px;
                      flex-direction: column;
                  }
                  .col.price > small{
                      font-weight: 500;
                      font-size: 8px;
                  }
                  [data-slice]{
                      white-space: nowrap;
                      overflow: hidden;
                      margin-right: 5px;
                  }
                  [data-fixed]{
                      display: flex;
                      align-items: center;
                  }
                  .sign-sale-footer{
                      width: 100%;
                      height: 10%;
                      display: flex;
                      font-size: 10px;
                  }
              `
            if (styleElem.styleSheet) {
                styleElem.styleSheet.cssText = css;
            }
            else {
                styleElem.appendChild(document.createTextNode(css));
            }

            let newWin = window.open('', '', 'height=500, width=500');
            newWin.document.write(a4.value.outerHTML);
            newWin.document.getElementsByTagName('head')[0].appendChild(styleElem);
            newWin.document.close();
            setTimeout(() => {
                is_sales_print.value = false
                newWin.print();
            }, 1000);
        }

        if (props.selected_signs && props.selected_signs.length > 0) {
            organise_signs(8, props.selected_signs)
        }

        printer_amount.value = []
        is_deleted.value = false
        watch(is_sales_print, () => {
            if (is_sales_print.value && props.selected_signs.length > 0) {
                setTimeout(() => {
                    handle_print()
                }, 500);
            }
            else if (is_sales_print.value && props.selected_signs.length == 0) {
                setTimeout(() => {
                    handle_print_catalogy()
                }, 500);
            }
        })

        watch(selected_deals.value, () => {
            organise_signs(8, selected_deals.value)
        })
        return {
            handle_print,
            pagination,
            a4,
        }
    }
}
</script>

<style scoped>
.blank-page {
    width: 100%;
    min-height: 100%;
    background: #fff;
    padding: 5px;
}

.wrapper {
    width: 100%;
    height: 297mm;
    display: grid;
    grid-template-columns: repeat(2, calc(100% / 2));
    grid-auto-rows: calc(100% / 4);
}

/* תצוגה מקדימה התואמת להדפסה: 1.5 ס"מ שמורים למעלה ו-1 ס"מ למטה בכל שלט */
.blank-page .sign {
    position: relative;
    width: 100%;
    height: 100%;
    border: 1px solid black;
    padding: 15mm 3mm 10mm 3mm;
}

.blank-page .sign::before {
    content: 'שמור 1.5 ס"מ';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 15mm;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #b5b5b5;
    font-size: 11px;
    border-bottom: 1px dashed #ff6347;
    pointer-events: none;
}

.blank-page .sign::after {
    content: 'שמור 1 ס"מ';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 10mm;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #b5b5b5;
    font-size: 11px;
    border-top: 1px dashed #ff6347;
    pointer-events: none;
}
</style>
